







































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    loggedIn: function() {
      return this.$store.state.user.isAuthenticated;
    }
  }
})
export default class Menu extends Vue {
  appPages = [
    {
      title: "Home",
      url: "/home",
      name: "home",
      icon: "home"
    },
    {
      title: "Networks",
      url: "/networks",
      name: "networks",
      icon: "git-network"
    },
    {
      title: "Devices",
      url: "/devices",
      icon: "phone-portrait"
    },
    {
      title: "Profiles",
      url: "/profiles",
      icon: "person"
    },
  ];

  navigate(url: string) {
    this.$router.directionOverride = 0;
    this.$router.push(url);
  }
  openTutorial() {
    this.$store.state.user.hasSeenTutorial = false;
    this.$router.push("tutorial");
  }
  logout() {
    this.$store.dispatch("logOut").then(() => {
      this.$router.push("/login");
    });
  }
}
